import { render, staticRenderFns } from "./SkyboxReservation.vue?vue&type=template&id=57967ec7"
import script from "./SkyboxReservation.vue?vue&type=script&lang=js"
export * from "./SkyboxReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports